"use client";

import { cn } from "@/lib/utils";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import ChipSerif from "@/components/global/ui/ChipSerif";
import checkbox from "@/public/challenge/checkbox.svg";
import { motion } from "framer-motion";
import FAQList from "@/components/global/ui/FAQList";
import { PortableTextBlock } from "sanity";
import iqicon from "@/public/affiliate/iqIcon.svg";
import { CTAButton } from "@/shadcn/ui/button";
import { PageTextOnlyLPOldDesignSchema } from "@/sanity/pages/PageTextOnlyLPOldDesignTemplate";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/shadcn/ui/carousel";
import Image from "@/helpers/Image";

export default function EmergedSection({
  data,
  className,
}: {
  data: PageTextOnlyLPOldDesignSchema;
  className?: string;
}) {
  return (
    <section
      className={cn(
        "relative overflow-clip pt-[5rem] lg:pt-[9rem] px-[4rem] lg:px-[6rem] w-full",
        className,
      )}
    >
      <div className="w-full flex flex-col items-start relative bg-white">
        {data.emergedTitle && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="w-full richtext richtext-start prose-h2:font-medium prose-h2:text-[4rem] lg:prose-h2:text-[4.5rem] lg:prose-h2:mb-[4rem] mb-[4rem] lg:prose-p:text-[2.25rem] prose-p:text-[#103037]/80"
          >
            <PortableText
              value={data.emergedTitle}
              components={richTextComponent}
            />
          </motion.div>
        )}

        {data.emergedContent && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="w-full richtext richtext-start prose-p:text-[2.25rem] lg:prose-p:text-[2.25rem] text-[#103037]/80
            prose-strong:text-[2.15rem] prose-strong:font-medium
            [&_.squareTopicListNoDivisor]:w-full [&_.squareTopicListNoDivisor]:mb-[3rem]
            prose-h4:mt-0 prose-h4:mb-[1.5rem] prose-h4:text-[#103037]/80 prose-h4:font-medium [&_br]:hidden lg:[&_br]:block"
          >
            <PortableText
              value={data.emergedContent}
              components={richTextComponent}
            />
          </motion.div>
        )}
      </div>
    </section>
  );
}
